var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('latte-ripple',{staticClass:"btn btn-icon btn-text btn-light scroll-btn",attrs:{"as":"button"},on:{"click":_vm.scrollDown}},[_c('i',{staticClass:"mdi mdi-chevron-down"})])}
var staticRenderFns = []

export { render, staticRenderFns }